import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { VscSettingsGear } from "react-icons/vsc";
import { Link } from "react-scroll";

const MobileNav = ({ mobileNav, setMobileNav }) => {
  return (
    <React.Fragment>
      <div>
        {mobileNav ? (
          <div className="bg-black/80 fixed w-full h-screen z-10 top-0 left-0"></div>
        ) : (
          ""
        )}
        <div
          className={
            mobileNav
              ? "fixed top-0 left-0 w-[150px] md:w-[250px] bg-white/100 z-10 duration-500"
              : "fixed top-0 left-[-100%] w-[150px] md:-[250px] h-screen bg-white/100 z-10 duration-500"
          }
        >
          {/* close icon for hamburger */}
          <AiOutlineClose
            size={30}
            onClick={() => setMobileNav(!mobileNav)}
            className="absolute right-4 top-4 cursor-pointer text-[#E84949] hover:bg-slate-100 hover:rounded "
          />
          <nav>
            <ul className="flex flex-col justify-center items-center p-2 text-gray-700 hover:cursor-pointer  ">
              <li className="hover:text-[#E84949] p-2">
                <Link
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  Home
                </Link>
              </li>
              <li to="/about" className="hover:text-[#E84949] p-2">
                <Link
                  to="about"
                  spy={true}
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  About
                </Link>
              </li>
              <li
                to="/project"
                className="flex gap-1 rounded p-2 text-[#E84949] hover:text-black"
              >
                <Link
                  to="projects"
                  spy={true}
                  smooth={true}
                  offset={50}
                  duration={500}
                  className="flex"
                >
                  <div className="flex w-[24px] top-[4.28%] left-0 bottom-[4%] right-0 font-bold">
                    <VscSettingsGear />
                    <VscSettingsGear size={20} className=" w-[10px] mt-1" />
                  </div>
                  Projects
                </Link>
              </li>
              <li to="/contact" className="hover:text-[#E84949] p-2">
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MobileNav;
